import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

const ClearIndicator = props => {
  const {
    selectProps: {
      input: { name }
    }
  } = props;
  return (
    <div data-desc={`select__${name}_clear`}>
      <components.ClearIndicator {...props} />
    </div>
  );
};

ClearIndicator.propTypes = {
  selectProps: PropTypes.any.isRequired
};

export default ClearIndicator;
